<template>
  <div class="daily-view">
    <header-vue />
    <transition name="fade">
      <div
        id="daily-section-container"
        :key="
          selectedProviderID +
            '.' +
            selectedYear +
            '.' +
            selectedMonth +
            '.' +
            selectedDayOfMonth
        "
        @touchstart="touchStarted"
        @mousedown="touchStartedMouse"
        @touchend="touchEnded"
        @mouseup="touchEndedMouse"
      >
        <section-vue />
        <footer-vue />
      </div>
    </transition>
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import FooterVue from "../../common/Footer.vue";
import SectionVue from "./Section.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { authMixin } from "../../../mixins/authMixin.js";

export default {
  mixins: [authMixin],
  data() {
    return {
      xStart: 0
    };
  },
  components: {
    HeaderVue,
    FooterVue,
    SectionVue
  },
  computed: {
    ...mapGetters({
      selectedProviderID: "getSelectedProviderID",
      selectedYear: "getSelectedYear",
      selectedMonth: "getSelectedMonth",
      selectedDayOfMonth: "getSelectedDayOfMonth"
    })
  },
  methods: {
    ...mapActions({
      getAppointmentDetails: "getAppointmentDetails"
    }),
    ...mapMutations({
      setDayOfMonth: "setDayOfMonth",
      setMonth: "setMonth",
      setYear: "setYear",
      setWeek: "setWeek",
      setWeekMonth: "setWeekMonth",
      setWeekYear: "setWeekYear",
      emptyAppointmentTypeEdit: "emptyAppointmentTypeEdit"
    }),
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    increaseDate() {
      // Step 1: Increase year
      const newDate = new Date(
        this.selectedYear,
        this.selectedMonth,
        this.selectedDayOfMonth + 1
      );

      // Step 2: Change year in state
      this.setDayOfMonth(newDate.getDate());
      this.setWeek(newDate.getDate());
      this.setMonth(newDate.getMonth());
      this.setYear(newDate.getFullYear());
      this.getAppointmentDetails();
    },
    decreaseDate() {
      // Step 1: Decrease year
      const newDate = new Date(
        this.selectedYear,
        this.selectedMonth,
        this.selectedDayOfMonth - 1
      );

      // Step 2: Change year in state
      this.setDayOfMonth(newDate.getDate());
      this.setWeek(newDate.getDate());
      this.setMonth(newDate.getMonth());
      this.setYear(newDate.getFullYear());
      this.getAppointmentDetails();
    },
    touchStarted(event) {
      this.xStart = event.changedTouches[0].screenX;
    },
    touchEnded(event) {
      const diff = event.changedTouches[0].screenX - this.xStart;
      if (Math.abs(diff) > 50 && diff > 0) {
        // Go to previous week
        this.decreaseDate();
      } else if (Math.abs(diff) > 50 && diff < 0) {
        // Go to next week
        this.increaseDate();
      }
    },
    touchStartedMouse(event) {
      this.xStart = event.screenX;
    },
    touchEndedMouse(event) {
      const diff = event.screenX - this.xStart;
      if (Math.abs(diff) > 50 && diff > 0) {
        // Go to previous week
        this.decreaseDate();
      } else if (Math.abs(diff) > 50 && diff < 0) {
        // Go to next week
        this.increaseDate();
      }
    }
  },
  created() {
    this.getAppointmentDetails();
    this.scrollToTop();
    this.emptyAppointmentTypeEdit();
  },
  watch: {
    selectedProviderID() {
      this.getAppointmentDetails();
    }
  }
};
</script>

<style scoped>
#daily-section-container {
  height: calc(100vh - 211px) !important;
  width: 100vw !important;
}
</style>
